import React from 'react'

export default function MemberAttendance({ ViewDetail, familyUserDetail }) {
    return (
        <>
            <div className="row">
                <div className="col-4">
                    <button className="btn text-capitalize d-block" type="button"
                        onClick={() => ViewDetail(familyUserDetail && familyUserDetail.class)}
                    > Classes
                    </button>
                    <button className="btn text-capitalize d-block" type="button"
                        onClick={() => ViewDetail(familyUserDetail && familyUserDetail.workshop)}
                    > Workshops
                    </button>
                    <button className="btn text-capitalize d-block" type="button"
                        onClick={() => ViewDetail(familyUserDetail && familyUserDetail.appointment)}
                    > Appointments
                    </button>
                    <button type="button" data-toggle="modal" data-target="#viewAttandance"
                        id="btn_view" className="btn text-capitalize w-100 mt-3" data-backdrop="static"
                        data-keyboard="false" style={{ display: "none" }}> </button>

                </div>
                <div className="col-8">
                    <p> Summary (in last 30 days): {familyUserDetail && familyUserDetail.class && familyUserDetail.class.current_month} </p>
                    <p> Summary (in last 30 days): {familyUserDetail && familyUserDetail.workshop && familyUserDetail.workshop.current_month} </p>
                    <p> Summary (in last 30 days): {familyUserDetail && familyUserDetail.appointment && familyUserDetail.appointment.current_month}</p>
                </div>
            </div>
        </>
    )
}
